import React from 'react';

import { Box, DataTable } from '../../../../common/components';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import formatDate from '../../../../helpers/formatDate';

export const OrganisationBrokers = ({ resource, goTo }) => {
  const handleRowClick = (row) => {
    goTo(`/admin/brokers/${row.id}`);
  };

  const resourceAttributes = resource.data.attributes;

  return (
    <Box>
      <h2 className="resource-name">{resourceAttributes.name}</h2>

      <DataTable
        source="/brokers"
        name="brokers"
        autoFilter={resource.data.id}
        autoFilterType="filter[organisation]"
        showTotal
        onRowSelect={handleRowClick}
      >
        <TableHeaderColumn dataField="id" isKey hidden />

        <TableHeaderColumn dataField="name" width={'380px'}>
          Name
        </TableHeaderColumn>

        <TableHeaderColumn dataField="branch_name" width={'200px'}>
          Branch
        </TableHeaderColumn>

        <TableHeaderColumn dataField="status" dataSort width={'100px'}>
          Status
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="created_at"
          dataFormat={formatDate}
          width={'180px'}
          dataSort
        >
          Created
        </TableHeaderColumn>
      </DataTable>
    </Box>
  );
};

export default connect(
  null,
  {
    goTo: push,
  },
)(OrganisationBrokers);
